module.exports = __webpack_public_path__ + "img/PL.51782097.svg";